<template>
  <div>
    <OrderContentFramework :button-name="'确认下单'" @response="orderPay" :totalMoney="totalMoney"
                           :showButton="showButton">
      <div class="content-block">
        <div class="block-item" @click="toggleShowMerchandises">
          <div>
            <span class="deep-text-color">订单编号：</span>
            <span class="light-text-color" style="font-size: 14px;">{{displayOrderNo}}</span>
          </div>
          <div>
            <i v-show="!showMerchandises" class="icon-font emkt-icon-zhankai research-font-color"></i>
            <i v-show="showMerchandises" class="icon-font emkt-icon-shouqi research-font-color"></i>
          </div>
        </div>
        <div class="full-split-line" v-show="showMerchandises"></div>
        <!--订单详情-->
        <service-product v-if="showMerchandises && isService" :order="order" :needSlove="true"></service-product>
        <OrderMerchandises v-if="showMerchandises && !isService" :order="order" ref='getPrice'/>
      </div>
      <!--结算方式、支付方式-->
      <div class="content-block">
        <div class="block-item">
          <div>
            <span class="deep-text-color">支付方式</span>
            <i class="icon-font emkt-icon-gantanhao light-text-color" style="font-size:13px;" @click="displayMessage(1)"></i>
          </div>
          <div @click="openPayMethodBox">
            <i class="icon-font emkt-icon-yue research-font-color"></i>
            <span class="light-text-color" style="font-size: 14px;">{{payTypeName}}</span>
            <i class="icon-font emkt-icon-lujing" style="font-size: 12px;"></i>
          </div>
        </div>
        <div class="split-line" v-if="showBalanceTypeMethod"></div>
        <div class="block-item" v-if="showBalanceTypeMethod">
          <div>
            <span class="deep-text-color">结算账户</span>
            <i class="icon-font emkt-icon-gantanhao light-text-color" style="font-size:13px;" @click="displayMessage(2)"></i>
          </div>
          <div @click="showChooseBalanceAccount = true">
            <i class="icon-font emkt-icon-bianzumergebeifen research-font-color"></i>
            <span class="light-text-color" style="font-size: 14px;">{{balanceTypeName}}</span>
            <i class="icon-font emkt-icon-lujing" style="font-size: 12px;"></i>
          </div>
        </div>
      </div>
<!--      <div class="content-block" v-show="selectedPayType === emkt.PAY_TYPE_FAPIAO">-->
<!--        <div class="block-item">-->
<!--          <span class="deep-text-color">发票</span>-->
<!--          <span class="light-text-color" style="font-size: 14px;">纸质发票</span>-->
<!--        </div>-->
<!--      </div>-->
      <div class="order-detail-content" v-show="selectedPayType === emkt.PAY_TYPE_FAPIAO">
        <div class="block-item" style="height: 60px;;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #424242;
line-height: 20px;">
          开票抬头
        </div>
        <div class="full-split-line"></div>
        <div class="block-item" v-for="(payEnterprise,index) in payEnterpriseList" style="border-bottom: .5px solid #efeef3;">
                    <label class="label-checkbox item-content">
                      <input type="checkbox" name="accountCheckbox"  :value="payEnterprise" v-model="ListPayEnterprise">
                      <div class="item-media group">
                        <i class="icon icon-form-checkbox i-style"></i>
                      </div>
                    </label>
          <div :class="getMainClass(payEnterprise)" >
            <div   style="margin-top: 10px;margin-left: 5px;font-size: 14px;" class="open-popup open-enterprise light-text-color" data-popup=".popup-invoice-title" @click="openSerchPayEnterprise(index,false)">
              {{getPayExperienceLabel(payEnterprise.enterpriseInvoiceTitle)}}
              <span v-if="!payEnterprise.enterpriseInvoiceTitle" class="light-text-color" style="font-size: 14px;">
                点击搜索单位
              </span>
              <span :style="getMainStyle(payEnterprise)">
              <span style="padding-right: 5px" v-if="canAddPayEnterprise">
               <img
                 @click="openSerchPayEnterprise(index,true)"
                 class="icon6"
                 style="width: 17px;height: 12px;"
                 referrerpolicy="no-referrer"
                 src="/static/img/修 改.svg"
               />
              </span>
            </span>
            </div>
          </div>
          <span>
          <div>
            <img
              v-if="canAddPayEnterprise"
              @click="removePayEnterprise(index)"
              class="icon5"
              referrerpolicy="no-referrer"
              src="/static/img/删减.svg"
            />
          </div>
            </span>
        </div>
        <div class="block-item" v-show="canAddPayEnterprise" @click="addPayEnterprise">
          <div>
            <span class="deep-text-color">增加开票抬头</span>
          </div>
          <div >
            <img
              class="label7"
              referrerpolicy="no-referrer"
              src="/static/img/增加备份.svg"
            />
          </div>
        </div>
      </div>
      <div class="layer7" v-show="selectedPayType === emkt.PAY_TYPE_FAPIAO">
          <span class="info2">
            开票抬头默认设置为您所在单位，您可以勾选以上所有单位或者新增
          </span>
        <span class="word10">
            。下单成功后，吉凯工作人员会主动联系您为您开具发票。
          </span>
      </div>
      <!--发票抬头-->
      <!--<div class="content-block" v-show="selectedPayType === emkt.PAY_TYPE_FAPIAO">-->
        <!--<img src="static/img/默认flag.png" class="default-flag">-->
        <!--<router-link class="block-item" :to="{ name: 'WeappInvoiceTitle', params: {order: order}}">-->
          <!--<span class="deep-text-color">发票抬头</span>-->
          <!--<div>-->
            <!--<i class="icon-font emkt-icon-lujing" style="font-size: 12px;"></i>-->
            <!--&lt;!&ndash;<span class="light-text-color">与注册单位相同</span>&ndash;&gt;-->
            <!--&lt;!&ndash;<label class="label-switch">&ndash;&gt;-->
              <!--&lt;!&ndash;<input type="checkbox"  v-model="fapiaoTitleSameAsEnterprise" @change="handleFapiaoTitleChange">&ndash;&gt;-->
              <!--&lt;!&ndash;<div class="checkbox" style="background-color: #5878fa;"></div>&ndash;&gt;-->
            <!--&lt;!&ndash;</label>&ndash;&gt;-->
          <!--</div>-->
        <!--</router-link>-->
        <!--<div class="split-line"></div>-->
        <!--<div class="block-item" v-if="defaultTitle">-->
          <!--<div>-->
            <!--<i class="icon-font emkt-icon-xingzhuangkaobei research-font-color"></i>-->
            <!--<span class="deep-text-color" style="font-weight: normal;margin-left: 10px;">{{defaultTitle}}</span>-->
          <!--</div>-->
          <!--<i class="icon-font emkt-icon-lujing" style="font-size: 12px;"></i>-->
        <!--</div>-->
      <!--</div>-->
<!--      发票寄送地址-->
      <div class="content-block" v-show="selectedPayType === emkt.PAY_TYPE_FAPIAO">
        <img src="static/img/默认flag.png" class="default-flag">
        <div class="block-item">
          <span class="deep-text-color">发票寄送地址</span>
          <div v-show="!isService">
            <span class="light-text-color">与收货地址相同</span>
            <label class="label-switch">
              <input type="checkbox"  v-model="defaultInvoiceAddress" @change="available">
              <div class="checkbox" :style="{'background-color': defaultInvoiceAddress ? '#5878fa' : '#e5e5e5'}"></div>
            </label>
          </div>
        </div>
        <div class="split-line"></div>
        <div v-if="!defaultInvoiceAddress">
          <router-link class="block-item" style="height: 81px;" v-if="displayInvoiceAddress" :to="{ name: 'WeappAddress', params: {order: order}}">
            <div class="block-address">
              <i class="icon-font emkt-icon-didian research-font-color" ></i>
              <div class="item-detail">
                <span class="deep-text-color">{{ displayInvoiceAddress.expressAddress}}</span>
                <span class="light-text-color">{{displayInvoiceAddress.consignee}} {{displayInvoiceAddress.expressMobile}}</span>
              </div>
            </div>
            <i class="icon-font emkt-icon-lujing light-text-color"></i>
          </router-link>
          <router-link class="block-item" style="height: 81px;" v-else :to="{ name: 'WeappAddress', params: {order: order}}">
            <div class="block-address" style="margin-left: 20px">
              <div class="item-detail" style="margin-left: 45px">
                <span style="color: #54c6fa; font-size: 12px; margin-left: 205px;">点击选择地址</span>
              </div>
            </div>
            <i class="icon-font emkt-icon-lujing light-text-color"></i>
          </router-link>
        </div>
        <div v-else>
          <div class="block-item" style="height: 81px;">
            <div class="block-address">
              <i class="icon-font emkt-icon-didian research-font-color" ></i>
              <div class="item-detail">
                <span class="deep-text-color">{{displayInvoiceAddress.expressAddress}}</span>
                <span class="light-text-color">{{displayInvoiceAddress.consignee}} {{displayInvoiceAddress.expressMobile}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
<!--      <div class="light-text-color" v-show="selectedPayType === emkt.PAY_TYPE_FAPIAO" style="padding: 0 15px;">下单成功后，吉凯工作人员会主动联系您为您开具发票</div>-->
    </OrderContentFramework>
    <div class="background-modal" v-if="showChooseBalanceAccount || showChoosePayMethod"></div>
    <div class="choose-balance-account" v-show="showChooseBalanceAccount">
      <div class="content-block">
        <div class="block-item" style="justify-content: center;">
          <span class="deep-text-color">结算账户</span>
        </div>
        <div class="split-line"></div>
        <div  v-for="(settlementAccount, index) in settlementAccountList">
          <div class="block-item">
            <div>
              <i class="icon-font emkt-icon-bianzumergebeifen research-font-color"></i>
              <span class="light-text-color" style="font-size: 14px;"><span style="font-size: x-small;color: red"> {{getSettmentType(settlementAccount)}}</span> {{settlementAccount.settlementAccountName}} <span v-if="settlementAccount.prepayCustomerNo" style="color: #0A7CE3;"> (账户余额)</span> </span>
            </div>
            <label class="label-checkbox item-content">
              <input v-model="selectedBalanceType" type="radio" name="accountCheckbox" :id="index" :value="settlementAccount">
              <div class="item-media group">
                <i class="icon icon-form-checkbox i-style"></i>
              </div>
            </label>
          </div>
          <div class="split-line"></div>
        </div>
<!--        <div class="block-item">-->
<!--          <div>-->
<!--            <i class="icon-font emkt-icon-yue research-font-color"></i>-->
<!--            <span class="light-text-color" style="font-size: 14px;">个人结算</span>-->
<!--          </div>-->
<!--          <label class="label-checkbox item-content">-->
<!--            <input v-model="selectedBalanceType" type="radio" name="accountCheckbox" :value="emkt.BALANCE_TYPE_CUSTOMER">-->
<!--            <div class="item-media group">-->
<!--              <i class="icon icon-form-checkbox i-style"></i>-->
<!--            </div>-->
<!--          </label>-->
<!--        </div>-->
<!--        <div class="split-line"></div>-->
        <div class="block-item" style="justify-content: center;">
          <div class="pay-btn research-background-color" style="width: 100%;" @click="updateBalanceAccount" v-if="chosenSettlementAccount !== null">完成</div>
          <div class="pay-btn " style="width: 100%;background-color: #7b7b7b" v-else >完成</div>
        </div>
      </div>
    </div>
    <div class="choose-pay-method" v-show="showChoosePayMethod">
      <div class="content-block">
        <div class="block-item" style="justify-content: center;">
          <span class="deep-text-color">支付方式</span>
        </div>
        <div class="split-line"></div>
        <div class="block-item">
          <div>
            <i class="icon-font emkt-icon-xingzhuangkaobei research-font-color"></i>
            <span class="light-text-color" style="font-size: 14px;">发票支付</span>
          </div>
          <label class="label-checkbox item-content">
            <input type="radio" name="payMethodCheckbox" v-model="selectedPayType" :value="emkt.PAY_TYPE_FAPIAO">
            <div class="item-media group">
              <i class="icon icon-form-checkbox i-style"></i>
            </div>
          </label>
        </div>
        <div class="split-line"></div>
        <div class="block-item">
          <div style="display: flex; align-items: center;">
            <i class="icon-font emkt-icon-yue research-font-color"></i>
            <span class="light-text-color" style="font-size: 14px; margin-left: 5px;">余额支付</span>
            <span class="tiny-font alert-text" style="margin-left: 5px;">可用余额：¥{{availableRestMoney}}</span>
          </div>
          <div style="display: flex; align-items: center;">
            <span class="tiny-font" style="color: #979797;" v-if="canUseOtherAccount">使用他人余额账户</span>
            <label class="label-checkbox item-content">
              <input type="radio" name="payMethodCheckbox" :value="emkt.PAY_TYPE_REMAIN_MONEY" v-model="selectedPayType">
              <div class="item-media group">
                <i class="icon icon-form-checkbox i-style"></i>
              </div>
            </label>
          </div>

        </div>
        <!--余额验证-->
        <div class="split-line"></div>
        <div v-show="showAccountVerifyBox">
          <div class="block-item" style="justify-content: flex-start;" @click="autofocus('search_name')">
            <div class="deep-text-color" style="width: 20%;">姓名</div>
            <input class="verity-info" v-model.trim="nameQuery" id="search_name" type="text" placeholder="请填写余额支付客户姓名">
          </div>
          <div class="split-line"></div>
          <div class="block-item" style="justify-content: flex-start;">
            <div @click="autofocus('search_mobile')" style="width: 80%;height: 100%;display: flex;align-items: center;">
              <div class="deep-text-color" style="width: 25%;">手机号</div>
              <input class="verity-info" v-model.trim="mobileQuery" id="search_mobile" type="text" placeholder="请填写余额支付客户手机号">
            </div>
            <div @click="checkRestMoneyAccount" class="pay-btn" style="width: 20%;color: #5878fa;border:1px solid #5878fa;line-height: 23px;height: 23px;font-size: 12px;" id="enterBtn">验证</div>
          </div>
          <div class="split-line"></div>
          <div class="block-item" style="justify-content: flex-start;" @click="autofocus('search_code')">
            <div class="deep-text-color" style="width: 20%;">验证码</div>
            <input class="verity-info" v-model.trim="verifyCode" id="search_code" type="text" placeholder="请输入验证码">
          </div>
          <div class="remind-info light-text-color">首次选择使用<span class="alert-text">余额支付</span>时，为保证账户安全，请准确填写余额账号的姓名和手机号码，发送<span class="alert-text">短信验证码</span>进行授权验证，请勿外泄账号密码等重要信息。
            <span class="alert-text">首次验证通过以后，再次使用时无需发送验证码。</span>
          </div>
        </div>
        <div class="block-item" style="justify-content: center;">
          <div class="pay-btn research-background-color" style="width: 100%;" @click="updatePayMethod">完成</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import emkt from './../../emkt'
  import { mapState, mapMutations } from 'vuex'
  import OrderMerchandises from './OrderMerchandises'
  import OrderContentFramework from './OrderContentFramework'
  import $ from 'jquery'
  import OrderConfirmationMixin from '../PrivateMixins/OrderConfirmationMixin'
  import wx from 'wx'
  import ServiceProduct from '../../views_fc/Order/ServiceProduct'
  export default {
    data () {
      return {
        isService: false,
        type: 'tools',
        fapiaoTitleSameAsEnterprise: false,
        showChooseBalanceAccount: false,
        showChoosePayMethod: false,
        showAccountVerifyBox: false,
        showMerchandises: false,
        verifyCode: '',
        nameQuery: '',
        mobileQuery: '',
        discountPrice: '',
        totalMoney: '',
        goodsMoney: '',
        expressPrice: '',
        orderList: [],
        showButton: false,
        order: null,
        selectedBalanceType: emkt.BALANCE_TYPE_CUSTOMER,
        selectedPayType: emkt.PAY_TYPE_FAPIAO,
        yueyanzheng: false,
        restPayCustomerNo: '',
        selectCoupon: null,
        defaultTitle: '',
        taxpayerIdentificationNo: '',
        invoiceAddress: [],
        SettlementAccountNameList: [],
        chosenSettlementAccount: null,
        chosenSettlementAccountName: '',
        workExperienceList: [],
        workExperienceNameList: [],
        ifNeedChooseWorkExperience: false,
        chosenWorkExperienceName: '',
        chosenWorkExperience: null,
        payTypeOptionMapping: {
          '1': 2,
          '3': 0,
          '6': 3,
          '7': 4
        },
        // usePrePay: false,
        // 验证他人余额账户是否成功
        verifyFinish: false,
        settlementAccountList: [],
        defaultInvoiceAddress: true,
        payEnterpriseIndex: null,
        payEnterpriseListData: [],
        ListPayEnterprise: [],
        firstLevelEnterpriseNoMap: emkt.getLocalStorage('EmktFirstLevelEnterpriseNoMap')
      }
    },
    components: {
      ServiceProduct,
      OrderMerchandises,
      OrderContentFramework
    },
    mixins: [OrderConfirmationMixin],
    computed: {
      ...mapState([
        'sessionInfo', 'currentWaitPayOrder', 'invoiceInfo'
      ]),
      displayOrderNo () {
        return (this.order && this.order.orderNo) || ''
      },
      availableRestMoney () {
        if (this.sessionInfo.customerInfo.prepayMoneyRemain === undefined || this.sessionInfo.customerInfo.prepayMoneyRemain === 0) {
          return 0
        } else {
          return this.sessionInfo.customerInfo.prepayMoneyRemain
        }
      },
      balanceTypeName () {
        return this.selectedBalanceType === emkt.BALANCE_TYPE_CUSTOMER ? '请选择结算账户' : this.chosenSettlementAccount === null ? '请选择结算账户' : this.chosenSettlementAccount.settlementAccountName
      },
      payTypeName () {
        return this.selectedPayType === emkt.PAY_TYPE_FAPIAO ? '发票支付' : '余额支付'
      },
      showBalanceTypeMethod () {
        // if (!this.settlementAccountList || this.settlementAccountList.length === 0) {
        //   return false
        // }
        return true
      },
      canUseOtherAccount () {
        if (this.order && !this.order.specialFundCouponUsed && this.availableRestMoney === 0) return true
        if (this.order && this.order.specialFundCouponUsed && this.order.specialFundCouponUsed === 1) return false
      },
      displayInvoiceAddress () {
        if (this.defaultInvoiceAddress && this.invoiceAddress && this.invoiceAddress.length > 0) {
          return this.invoiceAddress[0]
        } else if (!this.defaultInvoiceAddress) {
          return this.sessionInfo.expressAddress.find(item => item.addressStatus !== emkt.ADDRESS_STATUS.ADDRESS_STATUS_INVALID && (item.isDefault === 2 || item.isDefault === 3))
        } else {
          return {}
        }
      },
      payEnterpriseList () {
        return this.payEnterpriseListData
      },
      canAddPayEnterprise () {
        return this.payTypeName === '发票支付'
      }

    },
    watch: {
      'selectedPayType': {
        handler: 'handlePayTypeChange'
      },
      'selectedBalanceType': {
        handler: 'handleBalanceTypeChange'
      },
      'invoiceInfo': function (val) {
        const samePayEnterprise = this.payEnterpriseListData.find(mer => val.enterpriseNo === mer.enterpriseNo)
        console.log(samePayEnterprise)
        if (samePayEnterprise) {
          this.$weui.topTips('该开票抬头已经存在！不可重复添加！')
          return
        }
        var ldata = this.payEnterpriseListData[this.payEnterpriseIndex]
        const lsamePayEnterprise = this.ListPayEnterprise.findIndex(mer => ldata.enterpriseNo === mer.enterpriseNo)
        if (lsamePayEnterprise !== -1) {
            // 说明是修改
          this.ListPayEnterprise.splice(lsamePayEnterprise, 1, val)
        } else {
          this.ListPayEnterprise.push(val)
        }
        this.payEnterpriseListData.splice(this.payEnterpriseIndex, 1, val)
        console.log(val)
      },
      'ListPayEnterprise': function (val) {
        console.log('ListPayEnterprise', val)
      }
    },
    mounted () {
      this.solveServiceProduct(this.currentWaitPayOrder)
      this.setInitialFapiaoInfo()
      this.fetchTotalMoney()
      this.getResearchGroupAndWorkExperience()
      console.log(this.order, 'this.order')
    },
    // beforeRouteEnter (to, from, next) { // 若从活动页面跳转到登录页面，登录成功后返回活动页面
    //   console.log('to from ', to, from)
    //   next(vm => {
    //     if (from.name && (from.name === 'WeappOrderConfirmation')) {
    //       vm.gotoWeappCart()
    //     }
    //   })
    // },
    methods: {
      ...mapMutations([
        'UPDATE_RESEARCHGROUP_MEMBER_MAP', 'UPDATE_RESEARCHGROUP_SET'
      ]),
      solveServiceProduct (waitPayOrder) {
        if (waitPayOrder) {
          if (waitPayOrder.orderType === 3) {
            this.isService = true
            this.defaultInvoiceAddress = false
            this.available()
            waitPayOrder.solution = JSON.parse(waitPayOrder.solutionJson)
            // // 此处不是补丁，不可删除 todo duplicateDataType验证
            // waitPayOrder.solution.children.forEach(i => {
            //   i.groups.forEach(it => {
            //     if (it.parameterValues && it.parameterValues.length > 0) {
            //       it.parameterValues.forEach(ite => {
            //         if (ite.dataType) {
            //           ite.duplicateDataType = ite.dataType
            //         }
            //       })
            //     }
            //   })
            //   if (i.parameterValues && i.parameterValues.length > 0) {
            //     i.parameterValues.forEach(item => {
            //       item.duplicateDataType = item.dataType
            //     })
            //   }
            // })
            // waitPayOrder.solution.operationType = 20
            // waitPayOrder.solution.orderSource = 1
            this.order = waitPayOrder
            console.log(this.order.solution, '修补后的方案')
          } else {
            this.order = waitPayOrder
          }
        }
      },
      getResearchGroupAndWorkExperience (customerNo) {
        var _this = this
        customerNo = _this.sessionInfo.customerInfo.customerNo
        // 获取所有的课题组信息\
        _this.gcapi('getHistoricalPayEnterprises').then(res => {
          var list = res.body.result
          _this.payEnterpriseListData = []
          if (list && list.length > 0) {
            list.forEach(data => {
              let firstLevelEnterprise = this.firstLevelEnterpriseNoMap[data]
              if (firstLevelEnterprise && firstLevelEnterprise.enterpriseType !== emkt.ENTERPRISE_TYPE_COMPANY) {
                let payEnterprisedata = {'enterpriseInvoiceTitle': firstLevelEnterprise.enterpriseInvoiceTitle,
                  'enterpriseNo': firstLevelEnterprise.enterpriseNo }
                if (firstLevelEnterprise !== undefined) {
                  _this.payEnterpriseListData.push(payEnterprisedata)
                }
                this.$weui.loading('正在提交数据！').hide()
                // this.$weui.alert('开票抬头默认为' + firstLevelEnterprise.enterpriseInvoiceTitle)
              }
            })
          }
        }).then((response) => {
          _this.gcapi('getSettlementAccountListInfo', customerNo).then(res => {
            if (res.body.result) {
                    // const researchGroupMemberMap = res.body.result.bResearchGroupMemberMap
                    // const researchGroupSet = res.body.result.bResearchGroupList
                    // this.UPDATE_RESEARCHGROUP_MEMBER_MAP(researchGroupMemberMap)
                    // this.UPDATE_RESEARCHGROUP_SET(researchGroupSet)
                    // if (!this.researchGroupSet || this.researchGroupSet.length === 0) return
                    // // 获取所有课题组列表,选择课题组初始默认值
                    // this.researchGroupNameList = this.researchGroupSet.map((group) => {
                    //   return group.researchGroupName
                    // })
                    // // 选择第一个正常的课题组为默认课题组
                    // for (let i = 0; i < this.researchGroupSet.length; i++) {
                    //   if (this.researchGroupSet[i].status === emkt.RESEARCH_GROUP_STATUS_NORMAL) {
                    //     this.chosenResearchGroupName = this.researchGroupSet[i].researchGroupName
                    //     this.chosenResearchGroup = this.researchGroupSet[i]
                    //     break
                    //   }
                    // }
                    // console.log('researchGroupMemberMap', researchGroupMemberMap, researchGroupSet)
              _this.settlementAccountList = res.body.result
              if (!_this.settlementAccountList || _this.settlementAccountList.length === 0) {
                _this.$weui.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500)
                return
              }
                    // 获取所有课题组列表,选择课题组初始默认值
              _this.SettlementAccountNameList = _this.settlementAccountList.map((group) => {
                return group.settlementAccountName
              })
                    // 选择第一个正常的课题组为默认课题组
              for (let i = 0; i < _this.settlementAccountList.length; i++) {
                if (_this.settlementAccountList[i].settlementAccountStatus === emkt.SETTLEMENT_ACCOUNT_STATUS_NORMAL) {
                  _this.chosenSettlementAccountName = _this.settlementAccountList[i].researchGroupName
                  let payEnterprisedata = {enterpriseInvoiceTitle: _this.settlementAccountList[i].firstLevelEnterpriseInvoiceTitle,
                    enterpriseNo: _this.settlementAccountList[i].firstLevelEnterpriseNo }
                  _this.ListPayEnterprise.push(payEnterprisedata)
                  const ent = _this.payEnterpriseListData.find(data => data.enterpriseNo === payEnterprisedata.enterpriseNo)
                  let firstLevelEnterprise = this.firstLevelEnterpriseNoMap[_this.settlementAccountList[i].firstLevelEnterpriseNo]
                  if (!ent && firstLevelEnterprise && firstLevelEnterprise.enterpriseType !== emkt.ENTERPRISE_TYPE_COMPANY) {
                    _this.payEnterpriseListData.push(payEnterprisedata)
                  }
                  _this.chosenSettlementAccount = _this.settlementAccountList[i]
                  _this.selectedBalanceType = _this.chosenSettlementAccount
                  break
                }
              }
              if (_this.chosenSettlementAccount === null) {
                _this.$weui.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500)
                return
              }
            }
            // if (this.isService) {
              // this.buildServiceOrderParams(_this.sessionInfo.customerInfo.customerNo)
            // } else {
            _this.calculatePriceByAccountDiscountRatio(_this.sessionInfo.customerInfo.customerNo)
            // }
          })
        })
        // // 过滤掉无效的任职关系
        // this.gcapi('getWorkExperienceList', customerNo).then(res => {
        //   if (res && res.body.result) {
        //     const workList = res.body.result.filter(work => {
        //       return work.enable === true
        //     })
        //     emkt.setStoreItem('EmktWorkExperienceList', workList)
        //   } else {
        //     emkt.setStoreItem('EmktWorkExperienceList', [])
        //   }
        //   // 获取所有有效的任职关系列表，选择任职关系初始默认值
        //   this.workExperienceList = emkt.getLocalStorage('EmktWorkExperienceList')
        //   if (this.workExperienceList && this.workExperienceList.length > 0) {
        //     this.workExperienceNameList = this.workExperienceList.map(work => {
        //       return work.firstLevelEnterpriseName + (work.secondLevelEnterpriseName ? work.secondLevelEnterpriseName : '')
        //     })
        //   } else {
        //     // 如果该客户无任职关系信息，取客户的个人信息中的单位信息
        //     const customerInfo = this.sessionInfo.customerInfo
        //     if (customerInfo && customerInfo.enterpriseNo) {
        //       const enterprise = {
        //         firstLevelEnterpriseNo: customerInfo.enterpriseNo,
        //         firstLevelEnterpriseName: customerInfo.enterpriseName
        //       }
        //       this.workExperienceList = [enterprise]
        //       this.workExperienceNameList = [customerInfo.enterpriseName]
        //     }
        //   }
        //   // if (this.workExperienceNameList.length > 1) {
        //   //   this.ifNeedChooseWorkExperience = true
        //   // } else {
        //   //   this.ifNeedChooseWorkExperience = false
        //   // }
        //   this.chosenWorkExperienceName = this.workExperienceNameList[0]
        //   this.chosenWorkExperience = this.workExperienceList[0]
        //   console.log('nameList', this.settlementAccountList, this.SettlementAccountNameList, this.workExperienceList, this.workExperienceNameList)
        //   if (this.ifNeedChooseWorkExperience) {
        //     this.showOptionList('workExperience', 0)
        //   }
        //   console.log('EmktWorkExperienceList', emkt.getLocalStorage('EmktWorkExperienceList'))
        // })
      },
      setInitialFapiaoInfo () {
        var self = this
        let invoiceTitle = this.sessionInfo.invoiceTitle
        if (invoiceTitle) {
          let defTitle = invoiceTitle.filter(function (item) {
            return item.isDefault === 1
          })
          if (defTitle.length > 0) {
            this.defaultTitle = defTitle[0].enterpriseName
            this.taxpayerIdentificationNo = defTitle[0].invoiceTaxRegNo
          }
        }
        if (this.order) {
          let item = {}
          item.expressAddress = this.order.expressAddress
          item.consignee = this.order.expressContactor
          item.expressMobile = this.order.expressPhone
          item.province = ''
          item.city = ''
          item.district = ''
          self.invoiceAddress.push(item)
          if (emkt.getLocalStorage('defaultInvoiceAddress') === undefined || emkt.getLocalStorage('defaultInvoiceAddress') === true) {
            self.defaultInvoiceAddress = true
          } else {
            self.defaultInvoiceAddress = false
          }
        }
        // this.sessionInfo.invoiceAddress.forEach(function (item) {
        //   if (item.isDefault) {
        //     self.invoiceAddress.push(item)
        //     self.defaultInvoiceAddress = false
        //   }
        // })
      },
      available () {
        if (this.defaultInvoiceAddress) {
          emkt.setLocalStorage('defaultInvoiceAddress', true)
        } else {
          emkt.setLocalStorage('defaultInvoiceAddress', false)
        }
      },
      handleBalanceTypeChange () {
        if (this.selectedBalanceType !== emkt.BALANCE_TYPE_CUSTOMER) {
          let chosenName = this.selectedBalanceType.settlementAccountName
          let chosenAccount = this.selectedBalanceType.settlementAccountNo
          if (this.selectedBalanceType.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
            let status = this.selectedBalanceType.settlementAccountStatus
            if (status !== emkt.SETTLEMENT_ACCOUNT_STATUS_NORMAL) {
              this.selectedBalanceType = emkt.BALANCE_TYPE_CUSTOMER
              this.$weui.alert(chosenName + '已冻结，请联系业务员解锁')
              return
                  // return alert(chosenName + '未启用，请选择其他课题组')
            }
            let researchGroupStatus = this.selectedBalanceType.researchGroupStatus
            if (researchGroupStatus === emkt.RESEARCH_GROUP_STATUS_DISABLE) {
              this.selectedBalanceType = emkt.BALANCE_TYPE_CUSTOMER
              this.$weui.alert(`${chosenName}(${chosenAccount}):该课题组未启用，请选择其他结算账户`)
              return
                  // return alert(chosenName + '未启用，请选择其他课题组')
            }
            if (researchGroupStatus === emkt.RESEARCH_GROUP_STATUS_LOCKED) {
              this.selectedBalanceType = emkt.BALANCE_TYPE_CUSTOMER
              this.$weui.alert(`${chosenName}(${chosenAccount}):该课题组已冻结，请联系业务员解锁`)
              return
                  // return alert(chosenName + '未启用，请选择其他课题组')
            }
            if (researchGroupStatus === emkt.RESEARCH_GROUP_STATUS_EXPIRED) {
              this.selectedBalanceType = emkt.BALANCE_TYPE_CUSTOMER
              this.$weui.alert(`${chosenName}(${chosenAccount}):该课题组已过期，请选择其他结算账户`)
              return
                  // return alert(chosenName + '未启用，请选择其他课题组')
            }
          }
          console.log('selectedPayType', this.selectedPayType)
          this.checkSettmentAccount()
          this.showButton = true
          // this.$weui.topTips('您已选择' + chosenName + ',可用信用额度' + this.selectedBalanceType.availableCredit + '元', 2500, 'warning')
        // this.$weui.info('您已选择' + chosenName + ',可用信用额度' + this.selectedBalanceType.availableCredit + '元', 3000)
          this.chosenSettlementAccountName = chosenName
          this.chosenSettlementAccount = this.selectedBalanceType
          console.log('this.chosenSettlementAccount', this.chosenSettlementAccount)
          // this.updateChoice('research')
        } else {
          this.chosenSettlementAccountName = ''
          this.chosenSettlementAccount = null
          this.payEnterpriseListData = []
        }
      },
      checkSettmentAccount () {
        console.log(this.selectedPayType)
        if (this.selectedPayType === emkt.PAY_TYPE_REMAIN_MONEY) {
          if (this.restPayCustomerNo !== this.selectedBalanceType.prepayCustomerNo) {
            this.chosenSettlementAccountName = ''
            this.chosenSettlementAccount = null
            console.log(this.chosenSettlementAccount !== null)
            this.$weui.alert('选择账户余额结算时，必须使用账户余额绑定的结算账户，请重新选择结算账户！')
            return
          } else {
            this.payEnterpriseListData = []
            this.ListPayEnterprise = []
            let firstLevelEnterprise = this.firstLevelEnterpriseNoMap[this.selectedBalanceType.firstLevelEnterpriseNo]
            if (firstLevelEnterprise && firstLevelEnterprise.enterpriseType !== emkt.ENTERPRISE_TYPE_COMPANY) {
              let payEnterprisedata = {'enterpriseInvoiceTitle': firstLevelEnterprise.enterpriseInvoiceTitle,
                'enterpriseNo': firstLevelEnterprise.enterpriseNo }
              if (firstLevelEnterprise !== undefined) {
                this.payEnterpriseListData.push(payEnterprisedata)
                this.ListPayEnterprise.push(payEnterprisedata)
              }
                      // this.$weui.alert('开票抬头默认为' + firstLevelEnterprise.enterpriseInvoiceTitle)
            }
          }
        } else {
          if (this.selectedBalanceType.isBindPrepayCustomer && this.selectedBalanceType.prepayCustomerNo !== this.sessionInfo.customerInfo.customerNo) {
            this.chosenSettlementAccountName = ''
            this.chosenSettlementAccount = null
            this.payEnterpriseListData = []
            this.$weui.alert('该结算账户是您绑定的账户余额账号所绑定的结算账户，只有选择账户余额支付时才能使用，请选择其他结算账户')
            return
          }
        }
      },
      updateBalanceAccount () {
        this.showChooseBalanceAccount = false
        this.choosevip(this.payTypeOptionMapping[this.payType])
      },
      autofocus (id) {
        $('#' + id).focus()
      },
      toggleShowMerchandises () {
        this.showMerchandises = !this.showMerchandises
      },
      fetchTotalMoney () {
        if (this.currentWaitPayOrder) {
          let result = this.currentWaitPayOrder
          this.goodsMoney = result.price
          this.expressPrice = result.expressPrice
          this.totalMoney = result.totalPrice
          this.discountPrice = result.discountPrice ? Math.abs(+result.discountPrice) : 0
        }
      },
      getOptionListHtml (optionList, optionName) {
        const className = 'radio-input-attr'
        var ret1 = '<li class="item-content item-link" ><label class="label-checkbox item-content">' +
          '<input type="radio"  class="' + className + '" name="attr" value="'
        var ret2 = ''
        var ret3 = '" ><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 100%; word-wrap:break-word;text-align: left;">'
        var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 100%; word-wrap:break-word;text-align: left;">'
        let height = ''
        var length = 0
        let chosenValue = optionName === 'research' ? this.chosenSettlementAccountName : this.chosenWorkExperienceName
        for (var i = 0; i < optionList.length; i++) {
          let name = optionList[i]
          if (chosenValue === name) {
            ret2 += ret1 + name + '" id="' + i + ret4 + name + '</div></div></label></li>'
          } else {
            ret2 += ret1 + name + '" id="' + i + ret3 + name + '</div></div></label></li>'
          }
          length++
        }
        var ret
        if (length <= 7) {
          height = 2.1 * length + 1
          ret = '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        } else {
          ret = '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        }
        ret = ret + ret2 + '</ul></div></div>'
        return ret
      },
      showOptionList (optionName, chooseIndex) {
        if (optionName !== 'research' && this.ifNeedChooseWorkExperience === false) {
          console.log('不需要选择任职关系')
          // if (chooseIndex === 2) {
          //   this.payByRestMoney(true)
          // }
          return
        }
        let optionList = optionName === 'research' ? this.SettlementAccountNameList : this.workExperienceNameList
        let title = optionName === 'research' ? '请选择结算账户' : '请选择您目前的任职信息'
        let error = optionName === 'research' ? '您尚未新建过结算账户' : ''
        if (optionList.length === 0) {
          if (error) {
            // this.$weui.alert(error)
            alert(error)
          }
          return
        }
        // this.$weui.dialog({
        //   title: title,
        //   content: this.getOptionListHtml(optionList, optionName),
        //   buttons: [{
        //     label: '关闭',
        //     type: 'primary',
        //     onClick: () => {
        //     }
        //   }]
        // })
        $.modal({
          title: title,
          afterText: this.getOptionListHtml(optionList, optionName),
          buttons: [
            {
              text: '关闭',
              bold: true,
              onClick: () => {
              }
            }
          ]
        })
        const self = this
        $('.radio-input-attr').on('click', function (e) {
          e.preventDefault()
          if (optionName === 'research') {
            // debugger
            let id = $(this).attr('id')
            const chosenName = self.SettlementAccountNameList[id]
            console.log('radio id', id)
            if (self.settlementAccountList[id].settlementAccountStatus !== emkt.SETTLEMENT_ACCOUNT_STATUS_NORMAL) {
              return self.$weui.alert(chosenName + '已被冻结，请联系业务员解锁')
            }
            // if (self.settlementAccountList[id].status === emkt.RESEARCH_GROUP_STATUS_LOCKED) {
            //   return self.$weui.alert(chosenName + '已被冻结，请联系业务员解锁')
            // }
            // if (self.settlementAccountList[id].status === emkt.RESEARCH_GROUP_STATUS_EXPIRED) {
            //   return self.$weui.alert(chosenName + '已过期，请选择其他课题组')
            // }
            let val = $(this).val()
            console.log('click', val)
            $.closeModal()
            this.$weui.toast('您已选择' + val, 1500)
            // $.toast('您已选择' + val)
            self.chosenSettlementAccountName = val
            self.updateChoice(optionName)
            if (chooseIndex === 4) {
              let val = $(this).val()
              // debugger
              console.log('click', val)
              $.closeModal()
              // if (chooseIndex === 2 || chooseIndex === 4) {
              //   self.payByRestMoney(false)
              // }
            }
            self.calculatePriceByAccountDiscountRatio(self.customerNo)
          } else {
            let val = $(this).val()
            // debugger
            console.log('click', val)
            $.closeModal()
            self.chosenWorkExperienceName = val
            self.updateChoice(optionName)
            // if (chooseIndex === 2) {
            //   self.payByRestMoney(true)
            // }
          }
        })
      },
      updateChoice (optionName) {
        if (optionName === 'research' && this.chosenSettlementAccountName) {
          const index = this.SettlementAccountNameList.indexOf(this.chosenSettlementAccountName)
          if (index !== -1) {
            console.log('chosenSettlementAccount', this.chosenSettlementAccountName, this.settlementAccountList[index])
            this.chosenSettlementAccount = this.settlementAccountList[index]
          }
        }
        if (optionName !== 'research' && this.chosenWorkExperienceName) {
          const index = this.workExperienceNameList.indexOf(this.chosenWorkExperienceName)
          if (index !== -1) {
            console.log('chosenWorkExperience', this.workExperienceList[index])
            this.chosenWorkExperience = this.workExperienceList[index]
          }
        }
      },
      selectAddress () {
        if (!this.defaultInvoiceAddress) {
          this.$router.push({name: 'myInvoiceAddress', params: {order: this.order}})
        }
      },
      choosevip (index) {
        switch (index) {
          case 0:
            // 发票付款
            this.showOptionList('workExperience', index)
            this.calculatePriceByAccountDiscountRatio(this.sessionInfo.customerInfo.customerNo)
            break
          case 3:
            // 选择课题组结算发票支付
            this.calculatePriceByAccountDiscountRatio(this.sessionInfo.customerInfo.customerNo)
            break
          case 4:
            // 选择课题组结算余额支付 优惠促销以课题组优惠为主，但是余额账户金额需大于此订单金额
            this.calculatePriceByAccountDiscountRatio(this.sessionInfo.customerInfo.customerNo)
            break
          case 2:
            // 余额付款 更新选择的任职经历
            this.showOptionList('workExperience', index)
            this.calculatePriceByAccountDiscountRatio(this.restPayCustomerNo)
        }
      },
      goToGoodsDetail () {
        this.$router.push({name: 'orderContentDetail', query: {order: this.order}})
      },
      displayMessage (val) {
        if (!val) {
          return
        }
        let message
        let title = ''
        switch (val) {
          case 1:
            title = '支付方式说明'
            message = '支持发票支付(先货后款)和余额支付（账户余额支付）两种方式。选择发票支付下单后，我们将会主动联系您开具发票并安排寄送；选择余额支付后，您将使用自己账户的余额进行消费。也支持使用他人账户余额，使用前需进行系统验证。'
            break
          case 2:
            title = '结算账户说明'
            message = '结算方式分为个人结算账户与课题组账户结算两种方式。选择课题组结算，提交订单后，将计入您所在课题组的消费，根据课题组的月度结算方式进行货款支付。'
            break
          // case 4:
          //   message = '该订单包含【第三方】商品，此商品不支持余额付款。' +
          //     '请您使用线下付款或者将【第三方】商品与【自营】商品分开购买！'
          //   break
          // case 5:
          //   message = '订单提交后，将使用您的蓝V储值账户余额支付订单货款。余额不足时，' +
          //     '请选择其他支付方式。为保证账户安全，请勿外泄账号密码等重要信息。若需使用他人蓝V储值账户余额，' +
          //     '请准确填写储值帐号的姓名和手机号码进行授权。'
          //   break
          // case 2:
          //   message = '订单提交后，将使用您的信用支付额度支付订单货款。信用支付额度不足时，请选择其他支付方式。' +
          //     '同时，我们会将货款发票快递给您，请您根据发票上的信息将货款汇至我司账户。货款到位后，您的账户将恢复相应信用支付额度。' +
          //     '敬请在电汇凭证/支票的汇款用途栏或附言栏中填入销售确认单号或您的订单号，以便我们核对并确保您的订单能够及时发货。'
          //   break
          // case 6:
          //   message = '订单提交后，将计入您所在课题组的消费，根据课题组的月度结算方式进行货款支付。'
          //   break
          // case 7:
          //   message = '订单提交后，将计入您所在课题组的消费。同时订单货款将使用您的账户余额支付。余额不足时，请选择其他支付方式。' +
          //     '为保证账户安全，请勿外泄账号密码等重要信息。若需使用他人余额，请准确填写余额帐号的姓名和手机号码进行授权。'
        }
        this.$weui.dialog({
          title: title,
          content: message,
          buttons: [
            {
              label: '我知道了'
            }
          ]
        })
        // alert(message)
      },
      toMini (bOrders) {
        let so = []
        if (this.order.solution) {
          so.push(this.order.solution.id)
        } else {
          so.push({})
        }
        wx.miniProgram.navigateTo({
          url: '/pages/protocol/index?bOrders=' + JSON.stringify(bOrders) + '&solution=' + JSON.stringify(so)
        })
      },
      orderPay () {
        this.showButton = false
        if (this.chosenSettlementAccount === null) {
          return
        }
        if (this.ListPayEnterprise.length < 1) {
          this.$weui.topTips('请先填写订单开票抬头！', 3500)
          return
        }
        let saveItemInOrderKey = 0
        let convertedPayType = this.payType
        // 其余结算方式需要保存任职关系
        if (this.payType !== '6' && this.payType !== '7') {
          saveItemInOrderKey = 0
          console.log('this chosenwork', this.chosenWorkExperience)
        }
        // 课题组结算需要保存课题组信息
        if (this.payType === '6') {
          convertedPayType = '3'        // 课题组结算属于发票付款
          saveItemInOrderKey = 1
          console.log('this.chosenSettlementAccount', this.chosenSettlementAccount)
        }
        if (this.payType === '7') {
          convertedPayType = '1'        // 课题组结算属于账户余额
          saveItemInOrderKey = 1
          console.log('this.chosenSettlementAccount', this.chosenSettlementAccount)
          // if (!this.usePrePay) {
          //   alert('您使用的余额付款账户余额不够，不能使用该付款方式，请您选择其他付款方式')
          //   // setTimeout(() => { this.$weui.alert('您使用的余额付款账户余额不够，不能使用该付款方式，请您选择其他付款方式') }, 3000)
          //   // return
          // }
        }
        if (convertedPayType === '1') {
          if (this.restPayCustomerNo !== this.chosenSettlementAccount.prepayCustomerNo) {
            var Account = this.settlementAccountList.filter(d => {
              return d.prepayCustomerNo === this.restPayCustomerNo
            })
            var name = ''
            if (Account.length !== 0) {
              name = Account[0].settlementAccountName
            }
            alert('选择账户余额结算时，必须使用账户余额绑定的结算账户，请重新选择[' + name + ']结算账户！')
            // setTimeout(() => {
            //   this.$weui.alert('选择账户余额结算时，必须使用账户余额绑定的结算账户，请重新选择结算账户！')
            // }, 300)
            return
          }
        }
        if (convertedPayType === '1') {
          if (!this.verifyFinish && (this.sessionInfo.customerInfo.prepayMoneyRemain === undefined || this.sessionInfo.customerInfo.prepayMoneyRemain === 0)) {
            alert('使用余额付款必须先验证，请您先验证！')
            // setTimeout(() => {
            //   this.$weui.alert('使用余额付款必须先验证，请您先验证！')
            // }, 3000)
            return
          } else {
            this.successPay(saveItemInOrderKey, convertedPayType)
          }
        } else {
          if (this.selectedBalanceType.isBindPrepayCustomer && this.selectedBalanceType.prepayCustomerNo !== this.sessionInfo.customerInfo.customerNo) {
            // setTimeout(() => {
            //   this.$weui.alert('您选择的结算账户是您绑定的账户余额账号所绑定的结算账户，只有选择账户余额支付时才能使用')
            // }, 3000)
            alert('您选择的结算账户是您绑定的账户余额账号所绑定的结算账户，只有选择账户余额支付时才能使用')
            return
          }
          this.successPay(saveItemInOrderKey, convertedPayType)
        }
      },
      successPay (saveItemInOrderKey, convertedPayType) {
        console.log('this.chosenSettlementAccount', this.chosenSettlementAccount)
        console.log('saveItemInOrderKey', convertedPayType, saveItemInOrderKey)
        const saveItem = {}
        saveItem.settlementAccountNo = this.chosenSettlementAccount.settlementAccountNo
        if (this.chosenSettlementAccount === null) {
          this.$weui.alert('请选择结算账户或者联系业务员给您新建结算账户', 1500)
          return
        }
        saveItem.firstLevelEnterpriseNo = this.chosenSettlementAccount.firstLevelEnterpriseNo
        saveItem.firstLevelEnterpriseName = this.chosenSettlementAccount.firstLevelEnterpriseName
        saveItem.secondLevelEnterpriseNo = this.chosenSettlementAccount.secondLevelEnterpriseNo
        saveItem.secondLevelEnterpriseName = this.chosenSettlementAccount.secondLevelEnterpriseName
        if (saveItemInOrderKey === 1 && JSON.stringify(this.chosenSettlementAccount) !== '{}') {
          // if (!this.chosenSettlementAccount.discountA || !this.chosenSettlementAccount.discountB || !this.chosenSettlementAccount.discountC) {
          //   return alert('您选择的课题组未设置折扣率，请联系客服')
          // }
          saveItem.balanceType = 1   // 课题组结算
          saveItem.researchGroupApproveResult = 0 // 审批状态 不需要审批
          saveItem.researchGroupNo = this.chosenSettlementAccount.researchGroupNo
          saveItem.researchGroupName = this.chosenSettlementAccount.researchGroupName
        } else if (saveItemInOrderKey === 0 && JSON.stringify(this.chosenSettlementAccount) !== '{}') {
          saveItem.balanceType = 0   // 个人结算
          saveItem.researchGroupApproveResult = 0  // 审批状态 不需要审批
        }
        console.log('saveItem', saveItem)
        var self = this
        let bOrders = []
        let invoiceExpressContactor = ''
        let invoiceExpressAddress = ''
        let invoiceExpressPhone = ''

        if (convertedPayType === '3' && !this.displayInvoiceAddress) {
          self.$weui.topTips('请先添加发票寄送地址', 3500)
          return
        }
        if (convertedPayType === '3' && this.displayInvoiceAddress) {
          let invoice = this.displayInvoiceAddress
          invoiceExpressContactor = invoice.consignee
          invoiceExpressAddress = invoice.province + invoice.city + invoice.district + invoice.expressAddress
          invoiceExpressPhone = invoice.expressMobile
        } else {
          invoiceExpressContactor = ''
          invoiceExpressAddress = ''
          invoiceExpressPhone = ''
        }
        let payEnterpriseNos = []
        self.ListPayEnterprise.forEach(payEnterpriseNo => {
          if (payEnterpriseNo.enterpriseNo && payEnterpriseNo.enterpriseNo !== '') {
            payEnterpriseNos.push(payEnterpriseNo.enterpriseNo)
          }
        })
        if (payEnterpriseNos.length < 1) {
          self.$weui.topTips('请先填写订单开票抬头！', 3500)
          return
        }
        let bOrder = {
          payType: convertedPayType,
          id: this.order.id,
          invoiceTitle: this.defaultTitle,
          taxpayerIdentificationNo: this.taxpayerIdentificationNo,
          invoiceExpressContactor: invoiceExpressContactor,
          invoiceExpressAddress: invoiceExpressAddress,
          invoiceExpressPhone: invoiceExpressPhone,
          prepayCustomerNo: this.restPayCustomerNo,
          customerStoredPlanNo: '',
          payEnterpriseNos: payEnterpriseNos
        }
        if (this.isService) {
          bOrder.orderType = 3
          console.log(this.order, '修改审核状态的order对象')
        } else {
          bOrder.orderType = 1
        }
        Object.assign(bOrder, saveItem)
        console.log('border', bOrder)
        console.log('本订单选择的发票信息---》', this.ListPayEnterprise)
        bOrder.amplification = self.order.amplification
        bOrders.push(bOrder)
        this.gcapi('checkBeforeOrderPay', bOrders).then(res => {
          console.log(res.body)
          if (bOrder.orderType === 3) {
            this.showButton = true
            if (emkt.isWapp) {
              this.toMini(bOrders)
            } else {
              this.$router.push({name: 'centerController', params: {bOrders: bOrders, solution: this.order.solution.id}})
            }
          } else {
            this.$weui.loading().hide()
            this.showButton = true
            if (emkt.isWapp) {
              this.toMini(bOrders)
            } else {
              this.$router.push({name: 'centerController', params: {bOrders: bOrders}})
            }
          }
        })
      },
      checkInfo () {
        if (this.defaultTitle === '') {
          // $.toast('请选择发票抬头')
          return false
        } else {
          return true
        }
      },
      // buildServiceOrderParams (customerNo) {
      //   let object = {
      //     'customerNo': customerNo,
      //     'researchGroupNo': this.chosenSettlementAccount.researchGroupNo,
      //     'settlementAccountNo': this.chosenSettlementAccount.settlementAccountNo,
      //     'bOrders': {}
      //   }
      //   let bOrders = {
      //     'id': this.order.id,
      //     'payType': this.order.payType,
      //     'balanceType': this.order.balanceType,
      //     'amplification': this.order.amplification
      //   }
      //   object.bOrders = bOrders
      //   console.log(object, '构建完的object')
      // },
      calculatePriceByAccountDiscountRatio (customerNo) {
        this.$weui.loading('加载中....')
        var self = this
        if (self.chosenSettlementAccount === null) {
          self.$weui.topTips('请您选择可结算的结算账户', 2500)
          self.$weui.loading('加载中....').hide()
          return
        }
        if (Number(self.payType) === emkt.PAY_TYPE_REMAIN_MONEY && !self.chosenSettlementAccount.prepayCustomerNo) {
          self.$weui.topTips('选择账户余额结算时，必须使用账户余额绑定的结算账户，请联系客服！', 2500)
          self.$weui.loading('加载中....').hide()
          return
        }
        self.showButton = true
        self.yueyanzheng = true
        let bOrders = []
        let invoiceExpressContactor = ''
        let invoiceExpressAddress = ''
        let invoiceExpressPhone = ''
        if (this.displayInvoiceAddress) {
          let invoice = this.displayInvoiceAddress
          invoiceExpressContactor = invoice.consignee
          invoiceExpressAddress = invoice.province + invoice.city + invoice.district + invoice.expressAddress
          invoiceExpressPhone = invoice.expressMobile
        }
        let bOrder = {
          payType: self.payType,
          id: self.order.id,
          invoiceTitle: self.defaultTitle,
          taxpayerIdentificationNo: self.taxpayerIdentificationNo,
          invoiceExpressContactor: invoiceExpressContactor,
          invoiceExpressAddress: invoiceExpressAddress,
          invoiceExpressPhone: invoiceExpressPhone,
          prepayCustomerNo: customerNo,
          customerStoredPlanNo: ''
        }
        bOrder.amplification = self.order.amplification
        bOrders.push(bOrder)
        var obj = {}
        obj.bOrders = bOrders
        obj.customerNo = customerNo
        obj.settlementAccountNo = self.chosenSettlementAccount.settlementAccountNo
        // 计算折扣率时，传入结算方式和课题组编号
        if (self.payType === '6') {
          bOrder.payType = '3'
          if (self.chosenSettlementAccount.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
            bOrder.balanceType = emkt.BALANCE_TYPE_RESEARCH_GROUP
            obj.researchGroupNo = self.chosenSettlementAccount.researchGroupNo
          } else {
            bOrder.balanceType = emkt.BALANCE_TYPE_CUSTOMER
          }
        } else if (self.payType === '7') {
          bOrder.payType = '1'
          this.payEnterpriseListData = []
          this.ListPayEnterprise = []
          let firstLevelEnterprise = this.firstLevelEnterpriseNoMap[this.chosenSettlementAccount.firstLevelEnterpriseNo]
          let payEnterprisedata = {'enterpriseInvoiceTitle': firstLevelEnterprise.enterpriseInvoiceTitle,
            'enterpriseNo': firstLevelEnterprise.enterpriseNo }
          if (firstLevelEnterprise !== undefined && firstLevelEnterprise.enterpriseType !== emkt.ENTERPRISE_TYPE_COMPANY) {
            this.payEnterpriseListData.push(payEnterprisedata)
            this.ListPayEnterprise.push(payEnterprisedata)
          }
          if (self.chosenSettlementAccount.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
            bOrder.balanceType = emkt.BALANCE_TYPE_RESEARCH_GROUP
          } else {
            bOrder.balanceType = emkt.BALANCE_TYPE_CUSTOMER
          }
        } else {
          if (self.payType === '1') {
            this.payEnterpriseListData = []
            this.ListPayEnterprise = []
            let firstLevelEnterprise = this.firstLevelEnterpriseNoMap[this.chosenSettlementAccount.firstLevelEnterpriseNo]
            let payEnterprisedata = {'enterpriseInvoiceTitle': firstLevelEnterprise.enterpriseInvoiceTitle,
              'enterpriseNo': firstLevelEnterprise.enterpriseNo }
            if (firstLevelEnterprise !== undefined && firstLevelEnterprise.enterpriseType !== emkt.ENTERPRISE_TYPE_COMPANY) {
              this.payEnterpriseListData.push(payEnterprisedata)
              this.ListPayEnterprise.push(payEnterprisedata)
            }
          }
          bOrder.balanceType = emkt.BALANCE_TYPE_CUSTOMER
        }
        console.log('calculatePriceByAccountDiscountRatio', obj)
        if (self.isService) {
          self.gcapi('getServiceProductPriceByAccountDiscount', obj).then((res) => {
            this.$weui.loading('加载中....').hide()
            if (res.message) {
              this.$weui.topTips(res.message, 3000)
              this.showButton = false
              return
            }
            console.log(res, '服务类产品的调用新的接口的返回值')
            if (res.body.code === 0) {
              let result = res.body.result[0]
              // if (bOrder.payType === '1') {
              //   const obj = {'customerNo': self.restPayCustomerNo, 'price': result.price}
              //   self.gcapi('hasPrepayRemain', obj).then((response) => {
              //     if (!response.body.result) {
              //       self.usePrePay = false
              //       this.showButton = false
              //       self.$weui.alert('您使用的余额付款账户余额不够，不能使用该付款方式，请您选择其他付款方式')
              //     } else {
              //       self.usePrePay = true
              //     }
              //   })
              // }
              if (self.order) {
                self.order.price = result.price
                self.order.price = result.price
                self.order.initPrice = result.initPrice
                self.order.totalPrice = result.totalPrice
                self.order.discountPrice = result.discountPrice
                self.totalMoney = result.totalPrice
              }
            }
          })
        } else {
          self.gcapi('calculatePriceByAccountDiscountRatio', obj).then((response) => {
            this.$weui.loading('加载中....').hide()
            if (response.message) {
              this.$weui.topTips(response.message, 3000)
              this.showButton = false
              return
            }
            if (response.body.result !== null && response.body.result.length > 0) {
              self.selectCoupon = response.body.result[0].coupons && response.body.result[0].coupons[0]
              // var total = response.body.result[0].price
              // if (bOrder.payType === '1') {
              //   const obj = {'customerNo': self.restPayCustomerNo, 'price': response.body.result[0].price}
              //   self.gcapi('hasPrepayRemain', obj).then((response) => {
              //     if (!response.body.result) {
              //       self.usePrePay = false
              //       this.showButton = false
              //       self.$weui.alert('您使用的余额付款账户余额不够，不能使用该付款方式，请您选择其他付款方式')
              //     } else {
              //       self.usePrePay = true
              //     }
              //   })
              // }
              // self.gcapi('getSAOccupiedAmountAndExpiredInvoiceNum', this.chosenSettlementAccount.settlementAccountNo).then((response) => {
              //   let result = response.body.result
              //   if (result.availableCredit - total < 0) {
              //     self.$weui.alert('您使用的结算账户可用信用额度为' + result.availableCredit + '元，余额不够，请使用其他结算账户')
              //   }
              //   if (result.expiredInvoiceNum && result.expiredInvoiceNum > 0) {
              //     self.$weui.alert('您使用的结算账户有' + result.expiredInvoiceNum + '张超过信用期的发票，不可下单，请使用其他结算账户')
              //   }
              // })
              if (self.order.merchandises.length === 1) {
                self.order.merchandises[0].price = response.body.result[0].price
                self.order.merchandises[0].discountPrice = response.body.result[0].discountPrice
                self.order.price = response.body.result[0].price
                self.order.initPrice = response.body.result[0].initPrice
                self.order.totalPrice = response.body.result[0].totalPrice
                self.order.discountPrice = response.body.result[0].discountPrice
                self.totalMoney = response.body.result[0].totalPrice
              } else {
                var price = 0
                var totalPrice = 0
                var initPrice = 0
                var discountPrice = 0
                if (self.order.subOrders.length > 0) {
                  for (let i = 0; i < response.body.result[0].subOrders.length; i++) {
                    for (let j = 0; j < self.order.subOrders.length; j++) {
                      if (response.body.result[0].subOrders[i].id === self.order.subOrders[j].id) {
                        price = price + response.body.result[0].subOrders[i].price
                        initPrice = initPrice + response.body.result[0].subOrders[i].initPrice
                        totalPrice = totalPrice + response.body.result[0].subOrders[i].totalPrice
                        discountPrice = discountPrice + response.body.result[0].subOrders[i].discountPrice
                        if (!self.order.subOrders[j].isStock) {
                          self.order.subOrders[j].merchandises[0].price = response.body.result[0].subOrders[i].price
                          self.order.subOrders[j].merchandises[0].initPrice = response.body.result[0].subOrders[i].initPrice
                          self.order.subOrders[j].merchandises[0].discountPrice = response.body.result[0].subOrders[i].discountPrice
                        } else { // 增加现货折扣后价格
                          for (let n = 0; n < self.order.merchandises.length; n++) {
                            for (let o = 0; o < response.body.result[0].subOrders[i].stocks.length; o++) {
                              if (response.body.result[0].subOrders[i].stocks[o].merchandiseGuid === self.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                                self.order.merchandises[n].price = response.body.result[0].subOrders[i].stocks[o].price
                                self.order.merchandises[n].initPrice = response.body.result[0].subOrders[i].stocks[o].initPrice
                                self.order.merchandises[n].discountPrice = response.body.result[0].subOrders[i].stocks[o].discountPrice
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                } else if (response.body.result[0].subOrders.length > 0) {
                  for (let m = 0; m < response.body.result[0].subOrders.length; m++) {
                    for (let n = 0; n < self.order.merchandises.length; n++) {
                      if (response.body.result[0].subOrders[m].id === self.order.merchandises[n].orderGuid) {
                        if (response.body.result[0].subOrders[m].isStock && response.body.result[0].subOrders[m].stocks.length > 0) {
                          for (let o = 0; o < response.body.result[0].subOrders[m].stocks.length; o++) {
                            if (response.body.result[0].subOrders[m].stocks[o].merchandiseGuid === self.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                              price = price + response.body.result[0].subOrders[m].stocks[o].price
                              initPrice = initPrice + response.body.result[0].subOrders[m].stocks[o].initPrice
                              totalPrice = totalPrice + response.body.result[0].subOrders[m].stocks[o].totalPrice
                              discountPrice = discountPrice + response.body.result[0].subOrders[m].stocks[o].discountPrice
                            }
                          }
                        } else {
                          if (self.order.merchandises[n].presentQuantity === 0) {
                            price = price + response.body.result[0].subOrders[m].price
                            initPrice = initPrice + response.body.result[0].subOrders[m].initPrice
                            totalPrice = totalPrice + response.body.result[0].subOrders[m].totalPrice
                            discountPrice = discountPrice + response.body.result[0].subOrders[m].discountPrice
                          }
                        }
//                      if (self.order.merchandises[n].isStock) {
//                        discountPrice = discountPrice + self.order.merchandises[n].discountPrice
//                      } else {
//                        discountPrice = discountPrice + response.body.result[0].subOrders[m].discountPrice
//                      }
                        if (self.order.merchandises[n].categoryId === 20) {
                          self.order.merchandises[n].price = response.body.result[0].subOrders[m].price
                          self.order.merchandises[n].initPrice = response.body.result[0].subOrders[m].initPrice
                          self.order.merchandises[n].discountPrice = response.body.result[0].subOrders[m].discountPrice
                        } else if (self.order.merchandises[n].presentQuantity === 0) {
                          // 现货更新商品价格
                          for (let o = 0; o < response.body.result[0].subOrders[m].stocks.length; o++) {
                            if (response.body.result[0].subOrders[m].stocks[o].merchandiseGuid === self.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                              self.order.merchandises[n].price = response.body.result[0].subOrders[m].stocks[o].price
                              self.order.merchandises[n].initPrice = response.body.result[0].subOrders[m].stocks[o].initPrice
                              self.order.merchandises[n].discountPrice = response.body.result[0].subOrders[m].stocks[o].discountPrice
                            }
                          }
                        }
                      }
                    }
                  }
                } else { // 更新现货折扣后价格
                  if (response.body.result[0].isStock && response.body.result[0].stocks.length > 0) {
                    for (let n = 0; n < self.order.merchandises.length; n++) {
                      for (let o = 0; o < response.body.result[0].stocks.length; o++) {
                        if (response.body.result[0].stocks[o].merchandiseGuid === self.order.merchandises[n].merchandiseGuid && self.order.merchandises[n].presentQuantity === 0) {
                          price = price + response.body.result[0].stocks[o].price
                          initPrice = initPrice + response.body.result[0].stocks[o].initPrice
                          totalPrice = totalPrice + response.body.result[0].stocks[o].totalPrice
                          discountPrice = discountPrice + response.body.result[0].stocks[o].discountPrice

                          self.order.merchandises[n].price = response.body.result[0].stocks[o].price
                          self.order.merchandises[n].initPrice = response.body.result[0].stocks[o].initPrice
                          self.order.merchandises[n].discountPrice = response.body.result[0].stocks[o].discountPrice
                        }
                      }
                    }
                  }
                }
                self.order.price = price
                self.order.totalPrice = totalPrice
                self.order.initPrice = initPrice
                self.order.discountPrice = discountPrice
                self.totalMoney = totalPrice
              }
            }
          })
        }
      },
      getSettmentType (settlementAccount) {
        if (settlementAccount.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP) {
          return settlementAccount.researchGroupStatus === emkt.RESEARCH_GROUP_STATUS_DISABLE ? '*未启用' : settlementAccount.researchGroupStatus === emkt.RESEARCH_GROUP_STATUS_LOCKED ? '*已冻结' : settlementAccount.researchGroupStatus === emkt.RESEARCH_GROUP_STATUS_EXPIRED ? '*已过期' : ''
        } else {
          return ''
        }
      },
      getPayExperienceLabel (label) {
        if (label) {
          return label.length > 15 ? label.substring(0, 15) + '...' : label
        } else {
          return null
        }
      },
      getMainClass (payEnterprise) {
        return payEnterprise.enterpriseInvoiceTitle ? 'main3' : 'main3'
      },
      getMainStyle (payEnterprise) {
        return payEnterprise.enterpriseInvoiceTitle ? 'float: right;' : 'float: right;'
      },
      getTextStyle (payEnterprise) {
        return payEnterprise.enterpriseInvoiceTitle ? 'border: none;' : 'border: none; background-color: rgba(239, 238, 243, 1);'
      },
      addPayEnterprise () {
        let payEnterprise = {}
        this.payEnterpriseListData.push(payEnterprise)
        console.log('this.payEnterpriseList', this.payEnterpriseList)
      },
      removePayEnterprise (index) {
        var ldata = this.payEnterpriseListData[index]
        this.payEnterpriseListData.splice(index, 1)
        const lsamePayEnterprise = this.ListPayEnterprise.findIndex(mer => ldata.enterpriseNo === mer.enterpriseNo)
        if (lsamePayEnterprise !== -1) {
              // 说明是修改
          this.ListPayEnterprise.splice(lsamePayEnterprise, 1)
        }
        console.log('this.payEnterpriseList', this.payEnterpriseList)
      },
      openSerchPayEnterprise (index, val) {
        this.payEnterpriseIndex = index
      }
    }
  }
</script>

<style scoped>
  .tiny-font {
    font-size: 12px;
    transform: scale(0.8);
    transform-origin: left center;
  }
  .deep-text-color {
    color: #424242;
    font-size: 14px;
    font-weight: bold;
  }
  .bold-text {
    font-weight: bold;
  }
  .light-text-color {
    color: #929292;
    font-size: 12px;
  }
  .alert-text {
    color: #FE654D;
  }
  .container {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    position: relative;
    background-color: #FAFAFA;
  }
  .order-content {
    /*border: 1px solid #000000;*/
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 86px;
    overflow: scroll;
    padding: 10px;
    padding-bottom: 0;
    font-size: 12px;
  }
  .order-detail-content {
    margin-top: 0;
    padding: 0 15px;
    border-radius: 10px;
    border: 0.5px solid #EFEEF3;
    background-color: #fff;
    margin-bottom: 10px;
  }
  .footer {
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    font-size: 14px;
    height: 86px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    background-color: #fff;
  }
  .content-block {
    position: relative;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 0 15px;
    border-radius: 10px;
    width: 100%;
    border: 0.5px solid #EFEEF3;
    background-color: #fff;
  }
  .default-flag {
    width: 30px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .block-item {
    height: 62px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }
  .block-address {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 90%;
  }
  .item-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
    width: 85%;
  }
  .text-overflow-hidden {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .price-info {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  .pay-btn {
    width: 110px;
    height: 34px;
    border-radius: 17px;
    line-height: 34px;
    color: #fff;
    text-align: center;
  }
  .return-btn {
    width: 110px;
    height: 34px;
    border-radius: 17px;
    line-height: 34px;
    text-align: center;
    background-color: #fff;
    border:1px solid #5878fa;
  }
  .customer-service {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .split-line {
    border-top: .5px solid #efeef3;
    margin-right: -15px;
    height: 1px;
  }
  .full-split-line {
    border-top: .5px solid #efeef3;
    height: 1px;
  }
  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox:after {
    background: no-repeat center;
    background-image: url('/static/img/tick.png');
    background-size: .6rem .45rem;
  }

  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
  }
  .background-modal {
    opacity: 0.55;
    background: #000000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
  }
  .choose-balance-account, .choose-pay-method {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 10px;
    z-index: 20;
    font-size: 14px;
    color: #979797;
  }
  .verity-info {
    text-align: left;
    font-size: 14px;
    color: #979797;
    font-weight: normal;
    width: 60%;
    outline: none;
    border: none;
    padding: 0;
  }
  .verify-account {
    background-color: #FAFAFA;
    padding: 10px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 30;
    font-size: 14px;
  }
  .remind-info {
    line-height: 20px;
    padding: 0 10px;
  }

  .info4 {
    width: 32px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 16px;
    font-family: PingFangSC-Regular;
    line-height: 22px;
    text-align: left;
    align-self: flex-start;
    margin: 15px 0 0 20px;
    margin-bottom: 10px;
  }
  .main3 {
    border-radius: 5px;
    width: 100%;
    margin-left: 15px;
    margin-right: 15px;
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 20px;
    border-radius: 5px;
    background-color: rgba(250, 250, 250, 1);
    -ms-flex-item-align: start;
    align-self: flex-start;
    margin-top: 10px;
    /*background-color: rgba(249, 249, 249, 249);*/
  }
  .main3:active{
      background: #EFEEF3;
    }

  .main4 {
    border-radius: 5px;
    background-color: rgba(239, 238, 243, 1);
    justify-content: center;
    align-items: flex-start;
    padding-left: 1px;
    width: 222px;
    font-size: 14px;
    height: 40px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 20px;
  }
  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox:after {
    background: no-repeat center;
    background-image: url('/static/img/tick.png');
    background-size: .6rem .45rem;
  }

  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
  }
  label.label-checkbox input[type=checkbox]:checked+.item-media i.icon-form-checkbox, label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
  }
  .info2 {
     font-size: 12px;
     font-family: PingFangSC-Regular;
     color: rgba(254, 101, 77, 1);
     line-height: 20px;
   }
  .word10 {
    font-size: 12px;
    font-family: PingFangSC-Regular;
    color: rgba(146, 146, 146, 1);
    line-height: 20px;
  }
  .layer7 {
    z-index: 51;
    height: 60px;
    overflow-wrap: break-word;
    text-align: justify;
    align-self: center;
    margin-top: 10px;
    font-size: 0;
    margin-left: 15px;
    margin-right: 15px;
  }

</style>



// WEBPACK FOOTER //
// OrderConfirmation.vue?ee268684